import "./airdrop.scss";
import { useWeb3Context } from "../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "src/store/slices/state.interface";
import { claim } from "src/store/slices/airdrop-thunk";
import { useState, useCallback, useEffect } from "react";
import { Grid, InputAdornment, OutlinedInput, Zoom, Box, Modal } from "@material-ui/core";
import { formatValue, trim } from "../../helpers";
import { IPendingTxn, isPendingTxn, txnButtonText } from "../../store/slices/pending-txns-slice";
import { Skeleton } from "@material-ui/lab";
import { ethers } from "ethers";
import { getAddresses, Networks } from "src/constants";
import { AirdropContract, StableReserveContract } from "src/abi";
import { fetchAccountSuccess } from "src/store/slices/account-slice";

function Airdrop() {
    const dispatch = useDispatch();
    const { provider, address, connect, chainID, checkWrongNetwork } = useWeb3Context();
    const addresses = getAddresses(chainID);

    const [amount, setAmount] = useState<string>("");

    const isAppLoading = useSelector<IReduxState, boolean>(state => state.app.loading);
    const mntBalance = useSelector<IReduxState, string>(state => {
        return state.account.balances && state.account.balances.mnt;
    });
    const pendingTransactions = useSelector<IReduxState, IPendingTxn[]>(state => {
        return state.pendingTransactions;
    });

    const onClaim = async () => {
        if (await checkWrongNetwork()) return;
        await dispatch(claim({ address, provider, networkID: chainID }));
    };

    useEffect(() => {
        const getAmount = async () => {
            if (address) {
                const mntContract = new ethers.Contract(addresses.MNT_ADDRESS, StableReserveContract, provider);
                const mnt_balance = await mntContract.balanceOf(address);
                dispatch(
                    fetchAccountSuccess({
                        balances: {
                            mnt: ethers.utils.formatUnits(mnt_balance, "ether"),
                        },
                    }),
                );

                const airdropContract = new ethers.Contract(addresses.AIRDROP_ADDRESS, AirdropContract, provider);
                const airdrop_amount = await airdropContract.getClaimableAmount(address);
                setAmount(ethers.utils.formatUnits(airdrop_amount, "ether"));
            }
        };
        getAmount();
    }, [pendingTransactions]);

    return (
        <div className="stake-view">
            <Zoom in={true}>
                <div className="stake-card mb-3">
                    <Grid className="stake-card-grid" container direction="column" spacing={2}>
                        <Grid item>
                            <div className="stake-card-header">
                                <p className="stake-card-header-title">Airdrop</p>
                            </div>
                        </Grid>

                        <div className="stake-card-area">
                            {!address && (
                                <div className="stake-card-wallet-notification">
                                    <div className="stake-card-wallet-connect-btn" onClick={connect}>
                                        <p>Connect Wallet</p>
                                    </div>
                                    <p className="stake-card-wallet-desc-text">Connect your wallet!</p>
                                </div>
                            )}
                            {address && (
                                <div>
                                    <div className="stake-user-data">
                                        <div className="data-row">
                                            <p className="data-row-name">Earned</p>
                                            <p className="data-row-value">{isAppLoading ? <Skeleton width="80px" /> : <>{formatValue(amount)} MNT</>}</p>
                                        </div>
                                    </div>
                                    {Number(amount) > 0 && (
                                        <div className="stake-card-action-area">
                                            <div className="stake-card-action-row">
                                                <div className="stake-card-tab-panel-full">
                                                    <div
                                                        className="stake-card-tab-panel-btn secondary"
                                                        onClick={() => {
                                                            if (isPendingTxn(pendingTransactions, "airdrop_claim")) return;
                                                            onClaim();
                                                        }}
                                                    >
                                                        <p>{txnButtonText(pendingTransactions, "airdrop_claim", "Claim Airdrop")}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div className="stake-user-data">
                                        <div className="data-row">
                                            <p className="data-row-name">MNT Balance</p>
                                            <p className="data-row-value">{isAppLoading || !mntBalance ? <Skeleton width="80px" /> : <>{formatValue(mntBalance)} MNT</>}</p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </Grid>
                </div>
            </Zoom>
        </div>
    );
}
export default Airdrop;
